export enum ActionType {
    'LOAD' = 'load',
    'UNLOAD' = 'unload'
}
